const appendToEditor = (content: any, editorRef: any) => {
  if (!content || !editorRef) return;
  const { editor } = editorRef;
  if (!editor) return;
  const position = editor.state.doc.content.size;
  let commandChain = editor.chain().focus('end').setTextSelection(position);
  if (editor.isEmpty) {
    commandChain = commandChain.insertContent(content);
  } else {
    commandChain = commandChain.insertContentAt(position, content);
  }
  commandChain.run();
};

export default appendToEditor;
